export enum TextExtractionEventsEnum {
  MAIN_TO_RENDERER_TOGGLE_TEXT_EXTRACTION = 'MAIN_TO_RENDERER_TOGGLE_TEXT_EXTRACTION',
  RENDERER_TO_MAIN_TOGGLE_TEXT_EXTRACTION = 'RENDERER_TO_MAIN_TOGGLE_TEXT_EXTRACTION',
  RENDERER_TO_MAIN_SEND_EXTRACTED_TEXT = 'RENDERER_TO_MAIN_SEND_EXTRACTED_TEXT',
  MAIN_TO_RENDERER_SEND_EXTRACTED_TEXT = 'MAIN_TO_RENDERER_SEND_EXTRACTED_TEXT',
}
